/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReferralCreationEmailNotificationSummary { 
    attemptCount?: number;
    lastAttemptAt?: string;
    lastError?: string;
    notificationId?: string;
    queuedAt?: string;
    recipientEmail?: string;
    recipientType?: ReferralCreationEmailNotificationSummary.RecipientTypeEnum;
    sentAt?: string;
    status?: ReferralCreationEmailNotificationSummary.StatusEnum;
    subject?: string;
}
export namespace ReferralCreationEmailNotificationSummary {
    export const RecipientTypeEnum = {
        ProgramAssignedUser: 'PROGRAM_ASSIGNED_USER',
        ProbationOfficer: 'PROBATION_OFFICER'
    } as const;
    export type RecipientTypeEnum = typeof RecipientTypeEnum[keyof typeof RecipientTypeEnum];
    export const StatusEnum = {
        Pending: 'PENDING',
        Processing: 'PROCESSING',
        Sent: 'SENT',
        Failed: 'FAILED',
        Suppressed: 'SUPPRESSED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


